import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getBlogs, BlogPost } from '../services/blogServices';

function Blog() {
    const [selectedCategory, setSelectedCategory] = useState("");
    const [blogs, setBlogs] = useState<BlogPost[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let active = true;
        getBlogs()
            .then((posts) => {
                if (active) setBlogs(posts);
            })
            .catch(() => {
                if (active) setError("Couldn't load posts right now. Please try again later.");
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, []);

    // Categories derived from the tags present on the fetched posts.
    const categories = Array.from(new Set(blogs.flatMap((blog) => blog.categories)));

    const filteredBlogs = blogs.filter(
        (blog) => selectedCategory === "" || blog.categories.includes(selectedCategory)
    );

    return (
        <section className="py-5">
            <div className="container">
                <h2 className="fw-bold text-center mb-4">Blog</h2>

                {/* Category Filter */}
                <div className="text-center mb-4">
                    <button
                        className={`btn btn-outline-primary mx-2 ${selectedCategory === "" ? "active" : ""}`}
                        onClick={() => setSelectedCategory("")}
                    >
                        All
                    </button>
                    {categories.map(category => (
                        <button
                            key={category}
                            className={`btn btn-outline-primary mx-2 ${selectedCategory === category ? "active" : ""}`}
                            onClick={() => setSelectedCategory(category)}
                        >
                            {category}
                        </button>
                    ))}
                </div>

                {loading && <p className="text-center text-muted">Loading posts…</p>}
                {error && <p className="text-center text-danger">{error}</p>}
                {!loading && !error && filteredBlogs.length === 0 && (
                    <p className="text-center text-muted">No posts yet.</p>
                )}

                {/* Blog List */}
                <div className="row">
                    {filteredBlogs.map(blog => (
                        <div className="col-md-6 col-lg-4 mb-4" key={blog.id}>
                            <Link to={`/blog/${blog.slug}`}>
                                <div className="card shadow bnr-card h-100">
                                    {blog.thumbnailImgSrc && (
                                        <img
                                            src={blog.thumbnailImgSrc}
                                            alt={blog.thumbnailAltText}
                                            className="card-img-top"
                                            style={{ height: '200px', objectFit: 'cover' }}
                                        />
                                    )}
                                    <div className="card-body">
                                        <span className="badge bg-primary">{blog.publishDate.toLocaleDateString()}</span>
                                        <h5 className="card-title mt-2">{blog.title}</h5>
                                        <p
                                            className="text-muted"
                                            style={{
                                                display: '-webkit-box',
                                                WebkitLineClamp: 3,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                            }}
                                        >
                                            {blog.description}
                                        </p>
                                        <p className="text-muted small">By {blog.author}</p>
                                        <span className="btn btn-primary btn-sm">
                                            Read More
                                        </span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Blog;
